import React from 'react';

import styles from './base-select-button.module.scss';

interface Props {
    onClick: () => void;
    className: string;
}

const BaseSelectButton: React.FC<Props> = (props) => {
    const { onClick, children, className } = props;

    return (
        <button className={`${styles.selectButton} ${className}`} onClick={onClick}>
            {children}
        </button>
    );
};

export { BaseSelectButton };
